var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-adapter-check-single"},[_c('ul',{staticClass:"list-options-wrap"},_vm._l((_vm.localOptions),function(option){
var _obj;
return _c('li',{class:( _obj = {}, _obj["is-active"] = (option.key === _vm.localValue), _obj ),on:{"click":function($event){return _vm._onSelectOption(option)}}},[_c('div',{domProps:{"innerHTML":_vm._s(option.value)}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }